module.exports = __webpack_public_path__ + "img/virtual-icon-light.6cd89be.svg";